import React from 'react'
import classNames from 'classnames'

import CardNicknameDataCell from './card-nickname-data-cell'
import CardNumberDataCell from './card-number-data-cell'
import CheckedIcon from './checked-icon'
import UncheckedIcon from './unchecked-icon'
import RemoveIcon from './remove-icon'
import EditIcon from './edit-icon'
import { shouldPreventCreditCardRemoval } from '../my-saved-cards-table-helpers'

import styles from '../payment.css'

const getTableColumns = (
  isDesktopView, {
    handleRemoveCreditCard,
    handleEditCreditCard,
    handleCheckboxDefaultCard,
    removeCheckboxDefaultCard
  }
) => {
  const columns = [
    {
      Header: isDesktopView ? 'Card Number' : '',
      id: 'number',
      accessor: 'number',
      Cell: d => (
        <span className={styles.cellInfo}>
          <CardNumberDataCell
            type={d.original.type}
            number={d.original.number}
          />
        </span>
      ),
      minWidth: 35
    },
    {
      Header: 'Subscription Payments',
      id: 'useForSubscriptions',
      accessor: 'useForSubscriptions',
      Cell: d => (
        d.value ? <CheckedIcon /> : (
          <UncheckedIcon
            onClick={() => handleCheckboxDefaultCard(d, d.columnName)}
          />
        )
      ),
      minWidth: 27
    },
    {
      Header: 'Rentals',
      id: 'useForPurchases',
      accessor: 'useForPurchases',
      Cell: d => (
        d.value ? (
          <CheckedIcon
            onClick={() => removeCheckboxDefaultCard(d, d.columnName)}
          />
        ) : (
          <UncheckedIcon
            onClick={() => handleCheckboxDefaultCard(d, d.columnName)}
          />
        )
      ),
      minWidth: 27
    },
    {
      Header: 'Remove',
      id: 'remove',
      Cell: d => (
        <span className={styles.cellInfo}>
          <RemoveIcon
            onClick={() => { handleRemoveCreditCard(d.original.id) }}
            isDefault={shouldPreventCreditCardRemoval(d.original)}
          />
        </span>
      ),
      minWidth: 20
    },
    {
      Header: 'Edit',
      id: 'edit',
      Cell: d => (
        <span className={styles.cellInfo}>
          <EditIcon
            onClick={() => {
              handleEditCreditCard(d.original.id, d.index)
            }}
          />
        </span>
      ),
      minWidth: 20
    }
  ]

  // The Card Name is only displayed as the first column on desktop
  if (isDesktopView) {
    columns.unshift({
      Header: 'Card Name',
      id: 'nickname',
      accessor: 'nickname',
      Cell: d => (
        <span className={classNames(styles.cellInfo, styles.nicknameCell)}>
          <CardNicknameDataCell
            nickname={d.value}
          // TODO: LBXW-1418: Complete middleware api integration for invalid credit card status
          />
        </span>
      ),
      minWidth: 35
    })
  }
  return columns
}

export default getTableColumns
